import React, { FC } from 'react';
import MainPageLayout from 'components/Organization/MainPageLayout';
import InvitesListContent from 'shared/components/InvitesListContent';
import styles from './SuperAdminInviteList.module.scss';

const SuperAdminInviteList: FC = () => {
	return (
		<MainPageLayout>
			<div className={styles.container}>
				<div className={styles.block_title}>
					<h1 className="title">Invites List</h1>
					<InvitesListContent />
				</div>
			</div>
		</MainPageLayout>
	);
};

export default SuperAdminInviteList;
